import { generateUtilityClasses } from '../../utils';

export const tableSkeletonClasses = generateUtilityClasses('TableSkeleton', [
  'root',
  'head',
  'body',
  'row',
  'cell',
]);
